<template>
  <el-dialog
    class="register-dialog"
    :visible.sync="visible"
    width="40%"
    ref="registerDialog"
    @close="handleClose"
    center>
    <span slot="title" class="dialog-title" v-show="!successFlag">提交信息 完成注册</span>
    <div class="dialog-content dib tc" v-show="!successFlag">
      <el-form ref="registerForm" label-position="top" status-icon :model="registerForm" :rules="registerRules">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="registerForm.name" :maxlength="20" class="form-input name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="mobile">
          <el-input  v-model.number="registerForm.mobile" :maxlength="15" class="form-input mobile"></el-input>
        </el-form-item>
        <el-form-item label="图片验证码"  prop="validate">
          <el-input :maxlength="4" v-model="registerForm.validate" class="form-input validate">
            <img class="validate-img" slot="suffix" @click="changeCode" @mousedown="disableDrag"
                 :src="validateUrl" alt="请求失败,请检查网络"/>
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="registerForm.email" :maxlength="40" class="form-input email"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="company">
          <el-input v-model="registerForm.company" :maxlength="20" class="form-input company"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="submit-button" :class="{'disable-button': canSubmit}" @click="submitMessage" :disabled="canSubmit" round>提交信息</el-button>
    </div>
    <div class="dialog-content2 dib tc" v-show="successFlag">
      <img class="success-img" src="../../assets/img/downloadPanel/success.png" alt="提交成功"/>
      <div class="success-misc-main">提交成功</div>
      <div class="success-misc-sub">稍后会有顾问与您联系</div>
    </div>
  </el-dialog>
</template>
<script>
import { Loading } from 'element-ui'

export default {
  name: 'registerPanel',
  data () {
    var nameValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('姓名不能为空'))
      }
      callback()
    }
    var mobileValidate = (rule, value, callback) => {
      var isMob = /^0?1[3|4|5|8][0-9]\d{8}$/ // 手机号码
      if (!value) {
        return callback(new Error('联系方式不能为空'))
      }
      if (isMob.test(value)) {
        callback()
      } else {
        callback(new Error('联系方式格式错误'))
      }
    }
    var emailValidate = (rule, value, callback) => {
      var isEmail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/ // 邮箱
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      if (isEmail.test(value)) {
        callback()
      } else {
        callback(new Error('邮箱格式错误'))
      }
    }
    var codeValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'))
      }
      callback()
    }
    var codeValidate2 = (rule, value, callback) => {
      this.$api.post('/base/verifycode', { code: value }, (r) => {
        if (r.code === 0) {
          callback()
        } else {
          this.changeCode()
          callback(new Error('验证码错误！'))
        }
      })
    }
    return {
      visible: false,
      successFlag: false,
      IsDetileFlag: false,
      canSubmit: false,
      loadingArray: [],
      registerForm: {
        name: '',
        mobile: '',
        validate: '',
        email: '',
        company: ''
      },
      registerRules: {
        name: [
          { validator: nameValidate, trigger: 'blur', required: true }
        ],
        mobile: [
          { validator: mobileValidate, trigger: 'blur', required: true }
        ],
        validate: [
          { validator: codeValidate, trigger: 'blur', required: true },
          { validator: codeValidate2, trigger: 'submit' }
        ],
        email: [
          { validator: emailValidate, trigger: 'blur', required: true }
        ]
      },
      validateUrl: this.$global.globalPath + 'api/document/getcode'
    }
  },
  methods: {
    openDialog (bool, code) {
      this.visible = true
      this.successFlag = false
      this.canSubmit = false
      this.IsDetileFlag = bool
      this.changeCode()
      this.$nextTick(() => {
        this.$refs['registerForm'].resetFields()
      })
    },
    submitMessage () {
      this.canSubmit = true
      this.loadingArray = []
      this.$refs['registerForm'].validate((valid) => {
        if (valid) {
          this.callRegister()
        } else {
          this.handleInvalid()
          this.canSubmit = false
          return false
        }
      })
    },
    callRegister () {
      let loading = Loading.service({
        target: '.el-dialog--center',
        text: '正在提交您的信息，请稍候'
      })
      this.loadingArray.push(loading)
      let form = {
        mobile: this.registerForm.mobile,
        name: this.registerForm.name,
        company: this.registerForm.company,
        validate: this.registerForm.validate,
        registerpage: this.$router.currentRoute.meta.content + (this.$store.state.solutionNameData ? '(' + this.$store.state.solutionNameData + ')' : '')
      }
      this.$api.post('/base/register', form, (r) => {
        if (r.code === 0) {
          //            this.successFlag = true
          this.IsDetileFlag = true
          this.loadingArray.forEach(item => item.close())
          this.$message.success('注册成功,稍后会有顾问与您联系')
          this.loadingArray.forEach(item => {
            item = null
          })
          setTimeout(() => {
            this.visible = false
          }, 1500)
        } else {
          this.loadingArray.forEach(item => item.close())
          this.$message.error(r.data || '注册失败')
          setTimeout(() => {
            this.visible = false
          }, 1500)
        }
      })
    },
    changeCode () {
      let a = this.validateUrl
      this.validateUrl = ''
      this.$nextTick(() => {
        this.validateUrl = a
      })
    },
    disableDrag (event) {
      event.preventDefault()
    },
    handleClose () {
      this.$emit('close')
      if (this.IsDetileFlag === false) {
        if (this.$route.name === 'ClienteleDetile') {
          if (window.history.length > 1) {
            window.history.go(-1)
          } else if (window.history.length > 0 && this.$func.getCurrentBrowser() === ('Opera' || 'IE10' || 'IE9' || 'IE')) {
            window.history.go(-1)
          } else {
            window.close()
          }
        }
      }
    },
    handleInvalid () {
      this.$emit('invalid')
    }
  },
  created () {
  },
  mounted () {
    console.log(this.$router)
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/registerPanel.scss";
</style>



// WEBPACK FOOTER //
// registerPanel.vue?ef7e41a4